/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type ShippingDetailsAddress_item$ref = any;
export type ShippingDetailsAddress_item = {
    readonly address: {
        readonly itemAddress: string | null;
    } | null;
    readonly " $refType": ShippingDetailsAddress_item$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "ShippingDetailsAddress_item",
    "type": "Item",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "address",
            "storageKey": null,
            "args": null,
            "concreteType": "Address",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": "itemAddress",
                    "name": "displayCityStateCountry",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "fullCountryName",
                            "value": true
                        }
                    ],
                    "storageKey": "displayCityStateCountry(fullCountryName:true)"
                }
            ]
        }
    ]
} as any);
(node as any).hash = '3173fca534dba4603bb80568ca1bdba9';
export default node;
